import { Heading } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React from 'react'
import { Head } from '../../../src/component'

import { TrackPageViewed } from '../../../src/integrations/monitoring'
import { CheckoutPage } from '../../../src/model'
import { useCheckoutSizes } from '../../../src/utils/responsive'
import { VerifyStart } from '../../../src/component/VerifyStart/VerifyStart'

export const VerifyIdentityStartPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const { headingSize } = useCheckoutSizes()
  const pageTitle = `${t('verifyIdentity:start:title')} | ${t('common:brandName')}`

  return (
    <>
      <Head title={pageTitle} />
      <Heading size={headingSize}>{t('verifyIdentity:start:title')}</Heading>
      <VerifyStart />
      <TrackPageViewed />
    </>
  )
}
